<template>
  <section class="notify">
    <h3 class="title">
      《关于印发〈建造师执业资格考试实施办法〉和<br />
      〈建造师执业资格考核认定办法〉的通知》
    </h3>
    <a href="javascript:void(0);" class="down" @click="$refs.registerRef.open()">
      <span>2024年二级建造师报考专业对照表明细下载</span>
      <img src="@/assets/erjian/download_icon1.png" alt="" />
    </a>
    <register-dialog ref="registerRef"></register-dialog>
  </section>
</template>
<script>
import RegisterDialog from './register-dialog.vue'
export default {
  data() {
    return {}
  },
  components: {
    RegisterDialog
  }
}
</script>
<style lang="scss" scoped>
.notify {
  .title {
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    margin: 25px 0 15px;
    color: rgb(17, 67, 135);
    b {
      color: #d51719;
    }
  }
  .down {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 60px auto 0;
    img {
      vertical-align: middle;
      margin-left: 10px;
    }
    span {
      font-size: 22px;
      color: #d51719;
      text-decoration: underline;
    }
  }
}
</style>
